import styles from './CatalogGenrePage.module.css';

import { Header } from '../../../components/Header/Header';
import { useSearchParams } from 'react-router-dom';
import { useAllItemsQuery } from '../../../store/api/item.api';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard';

export const CatalogGenrePage = () => {
	
	const [searchParams] = useSearchParams();
	const genre = searchParams.get('genre');
	const schema = window.sessionStorage.getItem('schema');

	const { data: itemsData = [], isLoading: isItemsLoading } = useAllItemsQuery({ schema, params: { genre, category: genre } });

	return (
		<div className={'main'}>
			<Header />
			<div className={styles.header}>
				<div className={styles.title_block}>
					<h2>{genre}</h2>
				</div>
			</div>

			<div className={`result_container`}>
				{isItemsLoading ? (
					<p>Загрузка...</p>
				) : (
					<>
							{itemsData?.length === 0 && (
							<p>Ничего не найдено</p>
						)}

							{itemsData?.slice(0, 100).map(item => (
							<MinSliderCard
								from='genres'
								style={{ height: 356 }}
								key={item.id}
								title={item.title}
								price={item.price || item.P2_price}
								price_disc={item.min_price || item.price_disc || item.P2_price_disc}
								devices={item.devices}
								lang={item.lang}
								img={item.img}
								itemId={item.id}
								buyBtn={true}
								category={'item'}
							/>
						))}
					</>
				)}
			</div>
		</div>
	);
};
